import { DESCRIPTION } from '@/utils/const/activity/lvs';
import { Element } from 'react-scroll';
import styles from '../style.module.scss';
import { LVSH1 } from '../../widget';
import FadeIn from '@/components/commonComponents/fadeIn';

const Description = (props: typeof DESCRIPTION) => {
  const { title, content } = props;
  return (
    <Element name={title.main} key={title.main}>
      <div className={styles['activity-wrapper']}>
        <LVSH1 title={title.main} subTitle={title.vice} />
        <FadeIn>
          <div className={styles['description']}>{content}</div>
        </FadeIn>
      </div>
    </Element>
  );
};

export default Description;
